import { RootState } from "@store/index";
import { createSelector } from "reselect";
import { UIState } from "@store/ui/uiSlice";

const uiState = (state: RootState) => state.ui as UIState;

export const selectNewTestExtension = createSelector([uiState], (state) => state.newTestExtension);

export const selectShowOrgDetailInResults = createSelector(
  [uiState],
  (state) => state.showOrgDetailInResults,
);

export const selectConfigSaveButtonState = createSelector(
  [uiState],
  (state) => state.configSaveButtonState,
);

export const selectIsDoTheOtherEyeButtonPressed = createSelector(
  [uiState],
  (state) => state.isDoTheOtherEyeButtonPressed,
);

export const selectIsSkipVirtualAssistantModalOpen = createSelector(
  [uiState],
  (state) => state.isSkipVirtualAssistantModalOpen,
);

export const selectIsSkipCalibrationModalOpen = createSelector(
  [uiState],
  (state) => state.isSkipCalibrationModalOpen,
);

export const selectIsVABatchDownloadViewOpen = createSelector(
  [uiState],
  (state) => state.isVABatchDownloadViewOpen,
);
